export const COLORS = {

  main: {
    primary: {
      rgb: 'rgb(175, 202, 11)',
      hex: '#AFCA0B',
      hoverrgb: 'rgb(199, 217, 84)',
      hoverhex: '#C7D954'
    },
    secondary: {
      rgb: 'rgb(245, 166, 35)',
      hex: '#F5A623',
      hoverrgb: 'rgb(248, 193, 101)',
      hoverhex: '#F8C165'
    },
    signalColorError: {
      rgb: 'rgb(225, 35,  0)',
      hex: '#e02300',
    },
    signalColorWarning: {
      rgb: 'rgb(240, 145, 0)',
      hex: '#f09100',
    },
    signalColorSuccess: {
      rgb: 'rgb(140, 185, 0)',
      hex: '#8cb900',
    },
    signalColorInfo: {
      rgb: 'rgb(0,   85,  100)',
      hex: '#005563',
    },
    white: {
      rgb: 'rgb(255,  255 ,  255)',
      hex: '#FFFFFF',
    },
  },
  font: {

  },
  overlay: 'linear-gradient(#ffffff20, #AFCA0B)',

};



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/colors.ts